var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalcontainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.6665C18 5.34042 17.3679 4.06865 16.2426 3.13097C15.1174 2.19329 13.5913 1.6665 12 1.6665C10.4087 1.6665 8.88258 2.19329 7.75736 3.13097C6.63214 4.06865 6 5.34042 6 6.6665C6 12.4998 3 14.1665 3 14.1665H21C21 14.1665 18 12.4998 18 6.6665Z",
    stroke: "#239EC2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.73 17.5C13.5542 17.7526 13.3018 17.9622 12.9982 18.1079C12.6946 18.2537 12.3504 18.3304 12 18.3304C11.6496 18.3304 11.3054 18.2537 11.0018 18.1079C10.6982 17.9622 10.4458 17.7526 10.27 17.5",
    stroke: "#239EC2",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalcontainer);
export default __webpack_public_path__ + "static/media/Vertical container.bb3bebdfaad580a585c0db4f6473e900.svg";
export { ForwardRef as ReactComponent };